<template>
  <div>
    <DataTable :value="priceComputedList" v-if="priceComputedList !== null">
      <template #header>
        <div style="text-align: left">
          <Button label="Uppdatera artikelpriser" icon="pi pi-dollar" @click="saveArticles" :disabled="data === null" />
          <ProgressBar :value="percentDone" v-if="uploading" />
        </div>
      </template>
      <Column header="Artikel info" field="article" />
      <Column header="10,6-15 ton" field="first" />
      <Column header="25-30 ton" field="second" />
      <Column header="30,1-35 ton" field="third" />
      <Column header="35,1-40 ton" field="fourth" />
      <Column header="40,1-42 ton" field="fifth" />
      <Column header=">42 ton" field="sixth" />
    </DataTable>
  </div>
</template>

<script>

import DataTable from 'primevue/datatable'
import Column from 'primevue/column'
import Button from 'primevue/button'
import ProgressBar from 'primevue/progressbar'

import { mapGetters } from 'vuex'

export default {
  name: 'FeralcoArticlePriceList',
  components: {
    DataTable,
    Column,
    Button,
    ProgressBar
  },
  data () {
    return {
      uploading: false,
      percentDone: 0
    }
  },
  props: {
    data: Object
  },
  mounted () {
    this.$store.dispatch('GET_VISMA_ARTICLES')
  },
  computed: {
    ...mapGetters(['VISMA_ARTICLES']),
    priceComputedList () {
      return this.$props.data === null ? null : this.calculatePriceData(this.$props.data)
    }
  },
  methods: {
    async saveArticles (event) {
      this.uploading = true
      const articlePrices = this.calculatePriceData(this.$props.data)
      let count = 0
      for (const article of articlePrices) {
        await this.$store.dispatch('UPDATE_VISMA_ARTICE_PRICE', article)
        count++
        this.percentDone = Math.round((count / articlePrices.length) * 100)
      }
    },
    calculatePriceData (data) {
      return this.VISMA_ARTICLES.filter(e => e.data.distance !== null).map((a) => {
        const lowIndex = this.getLowRowIndex(a.data.distance, data.rows)
        return {
          id: a.id,
          article: this.createArticleName(a),
          first: this.calculatePrice(a.data.distance, 'first', data.rows[lowIndex], data.rows[lowIndex + 1]),
          second: this.calculatePrice(a.data.distance, 'second', data.rows[lowIndex], data.rows[lowIndex + 1]),
          third: this.calculatePrice(a.data.distance, 'third', data.rows[lowIndex], data.rows[lowIndex + 1]),
          fourth: this.calculatePrice(a.data.distance, 'fourth', data.rows[lowIndex], data.rows[lowIndex + 1]),
          fifth: this.calculatePrice(a.data.distance, 'fifth', data.rows[lowIndex], data.rows[lowIndex + 1]),
          sixth: this.calculatePrice(a.data.distance, 'sixth', data.rows[lowIndex], data.rows[lowIndex + 1])
        }
      })
    },
    createArticleName (article) {
      return article.data.name.split(' ')[0] + ' ' + article.artNbr + ' ' + article.data.distance + ' km'
    },
    calculatePrice (distance, column, low, high) {
      const lowVal = parseFloat(low[column].replace(',', '.'))
      const highVal = parseFloat(high[column].replace(',', '.'))
      return (lowVal + this.interpolateReminder(distance - low.km, lowVal, highVal)).toFixed(10)
    },
    interpolateReminder (rem, low, high) {
      const step = (high - low) / 10
      return rem * step
    },
    getLowRowIndex (distance, dataRows) {
      return dataRows.findIndex(e => (parseInt(e.km) + 10) > distance)
    }
  }
}
</script>

<style>

</style>



// WEBPACK FOOTER //
// src/components/FeralcoPrices/FeralcoArticlePriceList.vue